/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddToAssets = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="m20.5 7.2-8-5c-.3-.2-.7-.2-1.1 0l-8 5c-.2.1-.4.5-.4.8v8c0 .3.2.7.5.8l8 5c.3.2.7.2 1 0s.5-.5.5-.9v-7.4l6-3.8V14h2V8c0-.3-.2-.7-.5-.8zm-2.4.8L12 11.8 5.9 8 12 4.2zM5 9.8l6 3.8v5.6l-6-3.8z" />
      <path d="M19 16h-2v2h-2v2h2v2h2v-2h2v-2h-2z" />
    </g>
  </Icon>
);
export { SvgAddToAssets as AddToAssets };
